import { useQuery } from '@tanstack/react-query';
import { checkIsGuestSignedIn } from 'api/api';
import { getAllParamsFormUrl } from 'utils/getAllParamsFormUrl';

interface UseHandleAccessPointConnectionProps {
  enabled?: boolean;
  setIsLoading?: (isLoading: boolean) => void;
}

export const useHandleAccessPointConnection = ({
  enabled = true,
  setIsLoading,
}: UseHandleAccessPointConnectionProps) => {
  const params = getAllParamsFormUrl();

  const { data: isAuthorized = false } = useQuery({
    queryKey: ['checkGuestAuth', params?.macAddress],
    queryFn: async () => {
      if (!params?.macAddress) return false;
      try {
        const res = await checkIsGuestSignedIn({
          macAddress: params.macAddress,
          ...(params.siteName && { siteName: params.siteName }),
          ...(params.ssid && { ssid: params.ssid }),
        });
        setIsLoading?.(false);
        return res;
      } catch {
        setIsLoading?.(false);
        return false;
      }
    },
    enabled,
    refetchInterval: 10000,
    refetchIntervalInBackground: true,
    retry: true,
  });

  return {
    isAuthorized,
  };
};
